export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "expo-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "expo-themeWrapLive" */'./LiveThemeImporter'),
  },
};
